var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36, _circle37, _circle38, _circle39, _circle40, _circle41, _circle42, _circle43, _circle44, _circle45, _circle46, _circle47, _circle48, _circle49, _circle50, _circle51, _circle52, _circle53, _circle54, _circle55, _circle56;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDotBackgroundImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 146,
    height: 169,
    viewBox: "0 0 146 169",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3.83763,
    cy: 3.83763,
    r: 3.83763,
    fill: "#F4F4F4"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.83763,
    cy: 26.8634,
    r: 3.83763,
    fill: "#F4F4F4"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.83763,
    cy: 49.8892,
    r: 3.83763,
    fill: "#F4F4F4"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.83763,
    cy: 72.9151,
    r: 3.83763,
    fill: "#F4F4F4"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.83763,
    cy: 95.941,
    r: 3.83763,
    fill: "#F4F4F4"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.83763,
    cy: 118.967,
    r: 3.83763,
    fill: "#F4F4F4"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.83763,
    cy: 141.992,
    r: 3.83763,
    fill: "#F4F4F4"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.83763,
    cy: 165.018,
    r: 3.83763,
    fill: "#F4F4F4"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.8635,
    cy: 3.83763,
    r: 3.83763,
    fill: "#F4F4F4"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.8635,
    cy: 26.8634,
    r: 3.83763,
    fill: "#F4F4F4"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.8635,
    cy: 49.8892,
    r: 3.83763,
    fill: "#F4F4F4"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.8635,
    cy: 72.9151,
    r: 3.83763,
    fill: "#F4F4F4"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.8635,
    cy: 95.941,
    r: 3.83763,
    fill: "#F4F4F4"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.8635,
    cy: 118.967,
    r: 3.83763,
    fill: "#F4F4F4"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.8635,
    cy: 141.992,
    r: 3.83763,
    fill: "#F4F4F4"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.8635,
    cy: 165.018,
    r: 3.83763,
    fill: "#F4F4F4"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 49.8891,
    cy: 3.83763,
    r: 3.83763,
    fill: "#F4F4F4"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 49.8891,
    cy: 26.8634,
    r: 3.83763,
    fill: "#F4F4F4"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 49.8891,
    cy: 49.8892,
    r: 3.83763,
    fill: "#F4F4F4"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 49.8891,
    cy: 72.9151,
    r: 3.83763,
    fill: "#F4F4F4"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 49.8891,
    cy: 95.941,
    r: 3.83763,
    fill: "#F4F4F4"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 49.8891,
    cy: 118.967,
    r: 3.83763,
    fill: "#F4F4F4"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 49.8891,
    cy: 141.992,
    r: 3.83763,
    fill: "#F4F4F4"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 49.8891,
    cy: 165.018,
    r: 3.83763,
    fill: "#F4F4F4"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 72.915,
    cy: 3.83763,
    r: 3.83763,
    fill: "#F4F4F4"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 72.915,
    cy: 26.8634,
    r: 3.83763,
    fill: "#F4F4F4"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 72.915,
    cy: 49.8892,
    r: 3.83763,
    fill: "#F4F4F4"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 72.915,
    cy: 72.9151,
    r: 3.83763,
    fill: "#F4F4F4"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 72.915,
    cy: 95.941,
    r: 3.83763,
    fill: "#F4F4F4"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 72.915,
    cy: 118.967,
    r: 3.83763,
    fill: "#F4F4F4"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 72.915,
    cy: 141.992,
    r: 3.83763,
    fill: "#F4F4F4"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 72.915,
    cy: 165.018,
    r: 3.83763,
    fill: "#F4F4F4"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: 95.9409,
    cy: 3.83763,
    r: 3.83763,
    fill: "#F4F4F4"
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: 95.9409,
    cy: 26.8634,
    r: 3.83763,
    fill: "#F4F4F4"
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: 95.9409,
    cy: 49.8892,
    r: 3.83763,
    fill: "#F4F4F4"
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: 95.9409,
    cy: 72.9151,
    r: 3.83763,
    fill: "#F4F4F4"
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    cx: 95.9409,
    cy: 95.941,
    r: 3.83763,
    fill: "#F4F4F4"
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    cx: 95.9409,
    cy: 118.967,
    r: 3.83763,
    fill: "#F4F4F4"
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    cx: 95.9409,
    cy: 141.992,
    r: 3.83763,
    fill: "#F4F4F4"
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    cx: 95.9409,
    cy: 165.018,
    r: 3.83763,
    fill: "#F4F4F4"
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    cx: 118.967,
    cy: 3.83763,
    r: 3.83763,
    fill: "#F4F4F4"
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    cx: 118.967,
    cy: 26.8634,
    r: 3.83763,
    fill: "#F4F4F4"
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    cx: 118.967,
    cy: 49.8892,
    r: 3.83763,
    fill: "#F4F4F4"
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    cx: 118.967,
    cy: 72.9151,
    r: 3.83763,
    fill: "#F4F4F4"
  })), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    cx: 118.967,
    cy: 95.941,
    r: 3.83763,
    fill: "#F4F4F4"
  })), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    cx: 118.967,
    cy: 118.967,
    r: 3.83763,
    fill: "#F4F4F4"
  })), _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
    cx: 118.967,
    cy: 141.992,
    r: 3.83763,
    fill: "#F4F4F4"
  })), _circle48 || (_circle48 = /*#__PURE__*/React.createElement("circle", {
    cx: 118.967,
    cy: 165.018,
    r: 3.83763,
    fill: "#F4F4F4"
  })), _circle49 || (_circle49 = /*#__PURE__*/React.createElement("circle", {
    cx: 141.992,
    cy: 3.83763,
    r: 3.83763,
    fill: "#F4F4F4"
  })), _circle50 || (_circle50 = /*#__PURE__*/React.createElement("circle", {
    cx: 141.992,
    cy: 26.8634,
    r: 3.83763,
    fill: "#F4F4F4"
  })), _circle51 || (_circle51 = /*#__PURE__*/React.createElement("circle", {
    cx: 141.992,
    cy: 49.8892,
    r: 3.83763,
    fill: "#F4F4F4"
  })), _circle52 || (_circle52 = /*#__PURE__*/React.createElement("circle", {
    cx: 141.992,
    cy: 72.9151,
    r: 3.83763,
    fill: "#F4F4F4"
  })), _circle53 || (_circle53 = /*#__PURE__*/React.createElement("circle", {
    cx: 141.992,
    cy: 95.941,
    r: 3.83763,
    fill: "#F4F4F4"
  })), _circle54 || (_circle54 = /*#__PURE__*/React.createElement("circle", {
    cx: 141.992,
    cy: 118.967,
    r: 3.83763,
    fill: "#F4F4F4"
  })), _circle55 || (_circle55 = /*#__PURE__*/React.createElement("circle", {
    cx: 141.992,
    cy: 141.992,
    r: 3.83763,
    fill: "#F4F4F4"
  })), _circle56 || (_circle56 = /*#__PURE__*/React.createElement("circle", {
    cx: 141.992,
    cy: 165.018,
    r: 3.83763,
    fill: "#F4F4F4"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotBackgroundImg);
export default __webpack_public_path__ + "static/media/dotBackgroundImg.8bc10cbaffded82b5fd666ee8936e622.svg";
export { ForwardRef as ReactComponent };